<template>
  <div class="activety-box">
    <template v-if="detail">
      <preparatory-stage
        :startDate="detail.start1"
        :backgroundImage="preparatoryBackgroundImage"
        v-if="detail.status === 0"
      ></preparatory-stage>
      <submission-stage
        :status="detail.votesStatus"
        :votesType="detail.votesType"
        :uuid="uuid"
        :endDate="detail.end1"
        :backgroundImage="submissionBackgroundImage"
        v-if="detail.status === 1"
        @refresh="getDetail()"
      ></submission-stage>
      <voting-stage
        :endDate="detail.end2"
        :votesPlayerUuid="detail.votesPlayerUuid"
        :uuid="uuid"
        :votesType="detail.votesType"
        :backgroundImage="votingBackgroundImage"
        @voteSuccess="getDetail()"
        v-if="detail.status === 2"
      ></voting-stage>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import preparatoryStage from './preparatory-stage.vue';
import SubmissionStage from './submission-stage.vue';
import VotingStage from './voting-stage.vue';
import Login from '@/components/Login/index';

export default {
  components: { preparatoryStage, SubmissionStage, VotingStage },
  name: 'Contribute',
  props: {
    preparatoryBackgroundImage: {
      type: String
    },
    submissionBackgroundImage: {
      type: String
    },
    votingBackgroundImage: {
      type: String
    },
    rankPath: {
      type: String
    },
    votesType: {
      type: String
    }
  },
  data() {
    return {
      detail: null,
      mInterval: null
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo', 'token', 'refreshToken']),
    uuid() {
      if (this.userInfo && this.userInfo.uuid) {
        return this.userInfo.uuid;
      } else return '';
    }
  },
  mounted() {
    this.startCountdown();
  },
  methods: {
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    startCountdown() {
      let count = 0;
      this.mInterval = setInterval(() => {
        if (this.detail) {
          const now = new Date().getTime();
          let targetDate = 0;
          if (this.detail.status === 0) {
            targetDate = Number(this.detail.start1);
          } else if (this.detail.status === 1) {
            targetDate = Number(this.detail.start2);
          } else {
            targetDate = Number(this.detail.end2);
            const diff = targetDate - now;
            if (diff <= 0) {
              this.$router.replace(
                `/${this.rankPath}/${this.detail.votesType}`
              );
            }
          }
          const diff = targetDate - now;
          if (diff >= 0) {
            count++;
            if (count % 60 === 0) {
              this.getDetail();
            }
          }
        }
      }, 1000);
    },
    getDetail() {
      this.$http
        .get('/votes/get', { votesType: this.votesType })
        .then(({ data }) => {
          this.detail = data;
        });
    }
  },
  created() {
    this.$store.dispatch('app/getUserInfo').finally(() => {
      this.checkLogin().then(() => {
        this.getDetail();
      });
    });
  },
  beforeDestroy() {
    if (this.mInterval) {
      clearInterval(this.mInterval);
    }
  }
};
</script>
<style lang="scss" scoped>
.activety-box {
  width: 100%;
  // height: 100%;
  // background: url('./images/web-bg.png') no-repeat;
  background-size: cover;
  overflow: auto;
  display: flex;
  justify-content: center;
  background-color: #03002e;
}
</style>
